import axios from 'axios';
import BaseService from './baseService';
import { AuthState } from '@okta/okta-auth-js';

export interface GovernanceEnums {
    lobs: string[];
    products: string[];
    areas: string[];
    dataSensitivity: string[];
    apiStructures: string[];
    lifecycleStages: string[];
    technicalControlPoints: string[];
    dataOwners: string[];
    apiDataPrivacyAssessments: string[];
    licenseTypes: string[];
}

export const FALLBACK_ENUMS: GovernanceEnums = {
    lobs: [],
    products: [],
    areas: [],
    dataSensitivity: ['Public', 'Internal', 'Confidential', 'Restricted'],
    apiStructures: [
        'REST (Representational State Transfer) API',
        'SOAP (Simple Object Access Protocol) API',
        'GraphQL API',
        'gRPC (Google Remote Procedure Call) API',
        'WebSockets API',
        'Webhook (Event Callback) API',
        'RPC (Remote Procedure Call) API',
        'HATEOAS (Hypermedia as the Engine of Application State) API',
        'Streaming APIs',
        'Motorola Standard Native API',
    ],
    technicalControlPoints: ['API License Key', 'OAuth 2.0', 'Basic Authentication', 'SAML', 'JWT', 'Web Certificates', 'None'],
    lifecycleStages: ['Design', 'Development', 'Preview', 'Production', 'Deprecated', 'Retired'],
    dataOwners: ['Customer', 'Motorola Solutions', 'Other'],
    apiDataPrivacyAssessments: ['Yes', 'No', 'Not Sure'],
    licenseTypes: [
        'Open Source - Direct Download',
        'Public Domain - User Login',
        'Standard License - T&Cs',
        'Restricted License',
        'Internal Only',
        'Other',
    ],
};

export default class GovernanceService extends BaseService {
    constructor() {
        super();
    }

    public async getEnums(authState: AuthState | null): Promise<GovernanceEnums> {
        const response = await axios.get<GovernanceEnums>(
            `${this.REACT_APP_API_BASE_URL}/api/governance/enums`,
            this.getHeaders(authState),
        );
        return response.data;
    }
}
